export default __webpack_public_path__ + "static/media/EyeOpenIcon.829ce669.svg";